var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"dd-m-card dd-m-card--light-content"},[(_vm.item.question)?_c('h3',{staticClass:"dd-m-card--light-content__title"},[_vm._v(_vm._s(_vm.item.question))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dd-m-card--light-content__description"},[_vm._v("\n        "+_vm._s(_vm.item.answer)+"\n    ")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea68467a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/site/js/components/pages/product/question.vue
// module id = 705
// module chunks = 0